var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7839 5.33463L19.7241 6.39363L17.6061 4.27488L18.6651 3.21588C18.9569 2.92413 19.4324 2.92413 19.7241 3.21588L20.7839 4.27563C21.0756 4.56738 21.0756 5.04213 20.7839 5.33463ZM5.57987 20.5379L3.12512 20.8746L3.46112 18.4199L16.5471 5.33463L18.6659 7.45263L5.57987 20.5379ZM21.8429 3.21663L20.7839 2.15688C19.9071 1.28088 18.4829 1.28088 17.6061 2.15688L2.22437 17.5394C2.10887 17.6549 2.03387 17.8041 2.01212 17.9669L1.50662 21.6494C1.44437 22.1024 1.79912 22.4999 2.24912 22.4999C2.28287 22.4999 2.31662 22.4976 2.35037 22.4924L6.03287 21.9876C6.19487 21.9651 6.34562 21.8909 6.46037 21.7746L21.8429 6.39363C22.7189 5.51763 22.7189 4.09263 21.8429 3.21663Z",
    fill: "#0D0804"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilOutlined);
export default __webpack_public_path__ + "static/media/pencil-outlined.d824d8c828e0a13f18444953f9853746.svg";
export { ForwardRef as ReactComponent };